import { ca } from '@cian/analytics';
import { ICallbackParams } from '@cian/newbuilding-flat-view-order-component';

export function trackFlatViewOrderPopupOpen(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label,
    useLastProducts: true,
  });
}

export function trackFlatViewOrderSuccess(params: ICallbackParams) {
  const { date, time, phone, name, timestamp } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'PersonalTour',
    action: 'Success',
    label: 'Submit',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Featuring',
        date,
        time,
        phone,
        name,
        timestamp,
      },
    },
    useLastProducts: true,
  });
}
